import "shared/services/aws/awsConfig";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";

import { AppProviders } from "shared/providers/AppProviders";
import { AppRoutes } from "./routes";

import { Carregamento } from "shared/components/carregamento/Carregamento";
import { AuthContext } from "shared/contexts/Auth/AuthContext";
import { signInAsGuest } from "./shared/services/aws/cognito";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

function AppWrapper() {
  const { loadingAuth } = React.useContext(AuthContext);

  if (loadingAuth) {
    return <Carregamento />;
  }

  return <AppRoutes />;
}

/* ================================
   INICIAR APP
================================ */

async function iniciarApp() {
  try {
    await signInAsGuest();
  } catch (error) {
    console.error("Erro guest:", error);
  }

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AppProviders>
          <Toaster  position="top-center"  reverseOrder={false}
                             containerStyle={{zIndex: 999999,}}/>
          <AppWrapper />
        </AppProviders>
      </BrowserRouter>
    </React.StrictMode>,
  );
}

iniciarApp();
